/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AiRouteImport } from './routes/ai'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as EnterpriseRouteImport } from './routes/enterprise'
import { Route as ExperienceRouteImport } from './routes/experience'
import { Route as ExpertiseRouteImport } from './routes/expertise'
import { Route as InsightsRouteImport } from './routes/insights'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as VentureRouteImport } from './routes/venture'
import { Route as WorkRouteRouteImport } from './routes/work/route'
import { Route as WorkIndexRouteImport } from './routes/work/index'
import { Route as WorkSlugRouteImport } from './routes/work/$slug'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AiRoute = AiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const EnterpriseRoute = EnterpriseRouteImport.update({
  id: '/enterprise',
  path: '/enterprise',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperienceRoute = ExperienceRouteImport.update({
  id: '/experience',
  path: '/experience',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpertiseRoute = ExpertiseRouteImport.update({
  id: '/expertise',
  path: '/expertise',
  getParentRoute: () => rootRouteImport,
} as any)
const InsightsRoute = InsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const VentureRoute = VentureRouteImport.update({
  id: '/venture',
  path: '/venture',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkRouteRoute = WorkRouteRouteImport.update({
  id: '/work',
  path: '/work',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkIndexRoute = WorkIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkRouteRoute,
} as any)
const WorkSlugRoute = WorkSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => WorkRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/work': typeof WorkRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/ai': typeof AiRoute
  '/contact': typeof ContactRoute
  '/enterprise': typeof EnterpriseRoute
  '/experience': typeof ExperienceRoute
  '/expertise': typeof ExpertiseRoute
  '/insights': typeof InsightsRoute
  '/pricing': typeof PricingRoute
  '/venture': typeof VentureRoute
  '/work/$slug': typeof WorkSlugRoute
  '/work/': typeof WorkIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/ai': typeof AiRoute
  '/contact': typeof ContactRoute
  '/enterprise': typeof EnterpriseRoute
  '/experience': typeof ExperienceRoute
  '/expertise': typeof ExpertiseRoute
  '/insights': typeof InsightsRoute
  '/pricing': typeof PricingRoute
  '/venture': typeof VentureRoute
  '/work/$slug': typeof WorkSlugRoute
  '/work': typeof WorkIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/work': typeof WorkRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/ai': typeof AiRoute
  '/contact': typeof ContactRoute
  '/enterprise': typeof EnterpriseRoute
  '/experience': typeof ExperienceRoute
  '/expertise': typeof ExpertiseRoute
  '/insights': typeof InsightsRoute
  '/pricing': typeof PricingRoute
  '/venture': typeof VentureRoute
  '/work/$slug': typeof WorkSlugRoute
  '/work/': typeof WorkIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/work'
    | '/about'
    | '/ai'
    | '/contact'
    | '/enterprise'
    | '/experience'
    | '/expertise'
    | '/insights'
    | '/pricing'
    | '/venture'
    | '/work/$slug'
    | '/work/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/ai'
    | '/contact'
    | '/enterprise'
    | '/experience'
    | '/expertise'
    | '/insights'
    | '/pricing'
    | '/venture'
    | '/work/$slug'
    | '/work'
  id:
    | '__root__'
    | '/'
    | '/work'
    | '/about'
    | '/ai'
    | '/contact'
    | '/enterprise'
    | '/experience'
    | '/expertise'
    | '/insights'
    | '/pricing'
    | '/venture'
    | '/work/$slug'
    | '/work/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  WorkRouteRoute: typeof WorkRouteRouteWithChildren
  AboutRoute: typeof AboutRoute
  AiRoute: typeof AiRoute
  ContactRoute: typeof ContactRoute
  EnterpriseRoute: typeof EnterpriseRoute
  ExperienceRoute: typeof ExperienceRoute
  ExpertiseRoute: typeof ExpertiseRoute
  InsightsRoute: typeof InsightsRoute
  PricingRoute: typeof PricingRoute
  VentureRoute: typeof VentureRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai': {
      id: '/ai'
      path: '/ai'
      fullPath: '/ai'
      preLoaderRoute: typeof AiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/enterprise': {
      id: '/enterprise'
      path: '/enterprise'
      fullPath: '/enterprise'
      preLoaderRoute: typeof EnterpriseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experience': {
      id: '/experience'
      path: '/experience'
      fullPath: '/experience'
      preLoaderRoute: typeof ExperienceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expertise': {
      id: '/expertise'
      path: '/expertise'
      fullPath: '/expertise'
      preLoaderRoute: typeof ExpertiseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/insights': {
      id: '/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof InsightsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venture': {
      id: '/venture'
      path: '/venture'
      fullPath: '/venture'
      preLoaderRoute: typeof VentureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work': {
      id: '/work'
      path: '/work'
      fullPath: '/work'
      preLoaderRoute: typeof WorkRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work/': {
      id: '/work/'
      path: '/'
      fullPath: '/work/'
      preLoaderRoute: typeof WorkIndexRouteImport
      parentRoute: typeof WorkRouteRoute
    }
    '/work/$slug': {
      id: '/work/$slug'
      path: '/$slug'
      fullPath: '/work/$slug'
      preLoaderRoute: typeof WorkSlugRouteImport
      parentRoute: typeof WorkRouteRoute
    }
  }
}

interface WorkRouteRouteChildren {
  WorkSlugRoute: typeof WorkSlugRoute
  WorkIndexRoute: typeof WorkIndexRoute
}

const WorkRouteRouteChildren: WorkRouteRouteChildren = {
  WorkSlugRoute: WorkSlugRoute,
  WorkIndexRoute: WorkIndexRoute,
}

const WorkRouteRouteWithChildren = WorkRouteRoute._addFileChildren(
  WorkRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  WorkRouteRoute: WorkRouteRouteWithChildren,
  AboutRoute: AboutRoute,
  AiRoute: AiRoute,
  ContactRoute: ContactRoute,
  EnterpriseRoute: EnterpriseRoute,
  ExperienceRoute: ExperienceRoute,
  ExpertiseRoute: ExpertiseRoute,
  InsightsRoute: InsightsRoute,
  PricingRoute: PricingRoute,
  VentureRoute: VentureRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
